import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';

// ui
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import MaterialTable from 'material-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import orderBy from 'lodash/orderBy';

import { useTranslation } from 'react-i18next';

// components
import Modal2 from '../../../components/modal/Modal';
import RainfallChart from '../../rainfall/chart/RainfallChart';

// Provider
import ModeContext from '../../../context/ModeContext';

// style
import styles from '../../rainfall/lists/style';
import tableIcons from '../../../components/table/MaterialTableIcon';
import { StyledIconButton } from '../../../components/button/Button';
import RainfallStatusColor from '../../rainfall/map/RinfallStatusColor';

const useStyles = makeStyles(styles);

export default function Rainfall24hList() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [type] = useState('rainfall24h');
  const [error, setError] = useState('');
  const [datas, setDataRainfall24] = useState([]);
  const { currentMode, currentArea } = useContext(ModeContext);
  const [modalData, setModalData2] = useState({
    open: false,
    header: t('กราฟ'),
    subheader: null,
    content: null,
  });
  const [modalDataReset] = useState({
    open: false,
    header: '',
    subheader: null,
    content: null,
  });
  const unmounted = useRef(false);

  function filterData(currentData, mode, area) {
    let filterD = [];
    if (mode === 'province' && area.code !== '0') {
      filterD = datas.filter((d) => d.geocode.province_code === area.code);
    } else if (currentMode === 'basin' && area.code !== '0') {
      filterD = datas.filter((d) => d.basin.basin_code === area.code);
    } else {
      filterD = currentData;
    }

    return filterD;
  }

  function formatNumber(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function resetModal() {
    setModalData2(modalDataReset);
    modalData.open = false;
  }

  const handleChart = (data) => (e) => {
    e.preventDefault();

    setModalData2({
      open: true,
      header: `กราฟฝน ${data.station.tele_station_name.th}`,
      subheader: null,
      content: <RainfallChart
        filterData={datas}
        id={data.station.id}
        provinceId={data.geocode.province_code}
        selectedType={type}
        year={(data.rainfall_datetime).substring(0, 4)}
        month={(data.rainfall_datetime).substring(5, 7)}
        classes={classes}
      />,
    });
  };

  useEffect(() => {
    // if (modalData.open) modalData.open = false;
    const fetchData = async () => {
      fetch(`${process.env.REACT_APP_API_URL}/public/rain_24h`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          const currentDateTime = new Date();
          const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 2);

          const rainfall24Sort = orderBy(result.data, ['rain_24h'], ['desc']);
          const dataRainfall24h = rainfall24Sort.filter((d) => {
            const time = new Date(d.rainfall_datetime.replace(/-/g, '/')).getTime();
            return (last24hrs < time && d.rain_24h > 0);
          });
          setDataRainfall24(dataRainfall24h);
        })
        .catch((err) => setError(err));
    };
    fetchData();
    return () => { unmounted.current = true; };
  }, [modalData.open]);
  // modalData.open

  return (
    <>
      <Paper className={classes.root}>
        {error && <div>Error Occured</div>}
        <MaterialTable
          components={{
            Toolbar: () => (
              <div>
                <Box p={1} className={classes.title} alignItems="center" style={{ fontSize: 16, fontFamily: 'Kanit', fontWeight: 400 }}>{t('ปริมาณน้ำฝน')}</Box>
              </div>
            ),
          }}
          icons={tableIcons}
          columns={[
            {
              title: t('ชื่อสถานี'),
              title_export: t('ชื่อสถานี'),
              field: 'station.tele_station_name.th',
              width: 250,
              render: (rowData) => `สถานี${rowData.station.tele_station_name.th}`,
            },
            {
              title: `${t('ฝนล่าสุด')} ${t('(มม.)')}`,
              title_export: `${t('ฝนล่าสุด')} ${t('(มม.)')}`,
              field: 'rain_24h',
              type: 'numeric',
              width: 150,
              render: (rowData) => {
                const rain24h = parseFloat(rowData.rain_24h).toFixed(2);
                const rainfallStatusC = RainfallStatusColor(rain24h, type).color.statusColor;
                const rainfallStatusFontColor = RainfallStatusColor(rain24h, type)
                  .color.constrastColor;
                return (
                  <Box
                    borderRadius={3}
                    style={{
                      align: 'center',
                      textAlign: 'center',
                      margin: '0 auto',
                      backgroundColor: rainfallStatusC,
                      color: rainfallStatusFontColor,
                      width: '45px',
                    }}
                  >
                    {formatNumber(rowData.rain_24h)}
                  </Box>
                );
              },
            },
            {
              title: t('เวลา'),
              title_export: t('วันที่'),
              field: 'rainfall_datetime',
              type: 'date',
              width: 200,
              render: (rowData) => <div style={{ align: 'center', textAlign: 'rigth' }}>{`${rowData.rainfall_datetime.substring(rowData.rainfall_datetime.length - 5)} น.`}</div>,
            },
            {
              title: t('กราฟ'),
              field: '',
              title_export: '',
              sorting: false,
              type: 'numeric',
              render: (rowData) => (
                <>
                  {rowData.agency.agency_shortname.en !== 'DWR' ? (
                    <Tooltip title={`สถานี ${rowData.station.tele_station_name.th} \n ${t('คลิ๊กเพื่อแสดงกราฟฝน')}`}>
                      <StyledIconButton onClick={handleChart(rowData)}>
                        <FontAwesomeIcon icon={faChartLine} fontSize="small" style={{ padding: 0, color: '#888' }} />
                      </StyledIconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip title={`สถานี ${rowData.station.tele_station_name.th} \n ${t('ไม่มีข้อมูลฝน')}`}>
                      <StyledIconButton>
                        <FontAwesomeIcon icon={faChartLine} fontSize="small" style={{ padding: 0, color: '#dddddd' }} />
                      </StyledIconButton>
                    </Tooltip>
                  )}
                </>
              ),
            },
          ]}
          data={filterData(datas, currentMode, currentArea)}
          localization={{
            pagination: {
              labelRowsSelect: t('แถว'),
            },
            body: { emptyDataSourceMessage: <h3>{t('ไม่มีข้อมูลตามเงื่อนไข')}</h3> },
          }}
          options={{
            cellStyle: {
              padding: 8,
            },
            pageSize: 5,
            sorting: true,
            rowStyle: {
              wordWrap: 'break-word',
            },
            toolbar: true,
            showTitle: false,
            search: false,
          }}
        />
        <Modal2
          open={modalData.open}
          modalHeader={modalData.header}
          modalSubHeader={modalData.subheader}
          modalContent={modalData.content}
          resetModal={resetModal}
        />
      </Paper>
    </>
  );
}
